import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PillsSubtract"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 10.5C15.4457 10.5004 14.4105 10.7807 13.5 11.3123V6.75C13.5 3.85051 11.1495 1.5 8.25001 1.5C5.35052 1.5 3.00001 3.85051 3.00001 6.75V17.25C2.99558 19.4416 4.35561 21.4043 6.40908 22.17C8.46256 22.9356 10.7756 22.3423 12.207 20.6828C14.1083 22.6346 17.0863 23.0596 19.4576 21.7174C21.829 20.3753 22.9976 17.6034 22.3029 14.9686C21.6082 12.3339 19.2248 10.4985 16.5 10.5ZM14.4375 15.75H18.9375V17.25H14.4375V15.75ZM12 6.75C11.9975 4.67996 10.3201 3.00248 8.25001 3C6.17997 3.00248 4.50249 4.67996 4.50001 6.75V11.25H12V6.75ZM8.25001 21C6.17997 20.9975 4.50249 19.32 4.50001 17.25V12.75H11.8238C10.2828 14.659 10.0674 17.3167 11.2808 19.449C10.5757 20.4198 9.44982 20.996 8.25001 21ZM12.3425 18.2221C13.039 19.9036 14.6799 21 16.5 21C18.9841 20.9971 20.9971 18.9841 21 16.5C21 14.6799 19.9036 13.0391 18.222 12.3426C16.5405 11.646 14.605 12.031 13.318 13.318C12.031 14.605 11.646 16.5406 12.3425 18.2221Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PillsSubtract.vue"]]);
